import React from "react";
import { Content } from "../core/pdf/types";

export interface ElementState {
	parent: ElementState,
	def: Content,
}
export const ElementContext = React.createContext({} as ElementState);

export const useElementContext = function(def: Content) {
	const parent = React.useContext(ElementContext);

	const elementContext = React.useMemo(() => {
		return {
			parent,
			def,	
		};
	}, [parent, def]);

	return elementContext;
}